import { getGroupsUsers, removeAreaFromTrip, updateArea } from "@/api/group";
import { storeArea, updateGroupTrip } from "@/api/trip";
import PlusIcon from "@/assets/SVG/PlusIcon";
import TrashIcon from "@/assets/SVG/trashIcon";
import {
  Button,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { Form, Formik } from "formik";
import moment from "jalali-moment";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import ClockArea from "../areaManager/createAreaPop.jsx/clockArea";
import { AsarFormikInput } from "../asarInput";
import { Loader } from "../loader";
import CustomizedHook from "../project/autocomplatePro";
import { InputCreateProject } from "../project/createProjectPop";
import DatePicker from "../project/datePicker";

export default function CreateArea({
  selectedProject,
  tripDigest,
  onClose,
  edit = false,
}) {
  const [showDatePicker, setShowDatePicker] = useState();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showClock, setShowClock] = useState();
  const [initValues, setInitValues] = useState();
  useEffect(() => {
    if (!tripDigest) {
      setInitValues({ areas: [] });
      return;
    }

    if (tripDigest.startAt != null) {
      const datePart =
        tripDigest.startAt.indexOf("-") !== -1
          ? tripDigest.startAt?.split(" - ")[0]
          : tripDigest.startAt;
      const datePartEnd =
        tripDigest.endAt.indexOf("-") !== -1
          ? tripDigest.endAt?.split(" - ")[0]
          : tripDigest.endAt;

      // تجزیه سال، ماه و روز
      const [year, month, day] = datePart.split("/");
      const [yearEnd, monthEnd, dayEnd] = datePartEnd.split("/");

      // ساختن آرایه‌ای با دو آبجکت
      const dateDef = [
        { year: year, month: month, day: day },
        { year: yearEnd, month: monthEnd, day: dayEnd },
      ];

      setInitValues({
        tripName: tripDigest?.name,
        clockTime: tripDigest?.startAt?.split("-", 2)[1],
        clockTimeEnd: tripDigest?.endAt?.split("-", 2)[1],
        date: dateDef,
        countTrip: tripDigest.areas?.length ?? 0,
        areas: tripDigest.areas ?? [],
      });
    } else {
      setInitValues({
        areas: tripDigest.areas ?? [],
      });
    }
  }, [tripDigest]);

  const [options, setOptions] = useState();
  useEffect(() => {
    getGroupsUsers(`pageIndex=0&pageSize=1000`)
      .then((x) => {
        setOptions(
          x.content.map((itr) => ({
            value: itr.id,
            name: itr.name,
          })),
        );
      })
      .catch(() => {});
  }, []);

  const md = useMediaQuery("(max-width:450px)");

  const validationSchema = Yup.object({
    tripName: Yup.string().required("نام اردو الزامی است"),
    date: Yup.array()
      .required("تاریخ الزامی است")
      .min(2, "تاریخ الزامی است")
      .max(2, "تاریخ الزامی است"),
    clockTime: Yup.string().required("ساعت شروع و پایان الزامی است"),
    clockTimeEnd: Yup.string().required("ساعت شروع و پایان الزامی است"),
    areas: Yup.array()
      .required("وارد کردن اطلاعات حداقل 1 منطقه الزامی است")
      .min(1, "وارد کردن اطلاعات حداقل 1 منطقه الزامی است"),
  });

  if (!initValues) return;

  return (
    <Formik
      initialValues={initValues}
      validationSchema={validationSchema}
      validateOnBlur={false}
      validateOnChange={false}
      validateOnMount={false}
      onSubmit={async (values, actions) => {
        const timestamp = moment
          .from(
            `${values.date[0].year}/${values.date[0].month}/${values.date[0].day}`,
            "fa",
            "YYYY/MM/DD",
          )
          .valueOf();
        const timestampEnd = moment
          .from(
            `${values.date[1].year}/${values.date[1].month}/${values.date[1].day}`,
            "fa",
            "YYYY/MM/DD",
          )
          .valueOf();

        updateGroupTrip(tripDigest.id, {
          name: values.tripName,
          startAt: timestamp,
          endAt: timestampEnd,
          dailyStartAt: values.clockTime,
          dailyEndAt: values.clockTimeEnd,
        })
          .then(async () => {
            if (edit) {
              await updateArea(
                tripDigest.id,
                values.areas.map((area) => ({
                  areaId: area.id.toString().length < 15 ? null : area.id,
                  name: area.name,
                  owner: area.owner,
                })),
              )
                .then(() => {
                  window.location.reload();
                  onClose();
                })
                .catch(() => {});
            } else {
              await storeArea(
                tripDigest.id,
                values.areas.map((area) => ({
                  name: area.name,
                  owner: area.owner,
                })),
              )
                .then(() => {
                  navigate("/trips");
                  onClose();
                })
                .catch(() => {});
            }
          })
          .catch(() => {})
          .finally(() => actions.setSubmitting(false));
      }}
    >
      {({ values, setValues, errors, isSubmitting, submitForm }) => (
        <Form style={{ width: "100%" }}>
          {(loading || isSubmitting) && <Loader />}
          <Grid
            display={"flex"}
            flexDirection={"column"}
            gap={"20px"}
            width={"100%"}
          >
            <DatePicker
              sx={{ marginLeft: "-30px !important" }}
              date={values.date}
              setDate={(d) =>
                setValues((prevValues) => ({
                  ...prevValues,
                  date: d,
                }))
              }
              show={showDatePicker}
              setShow={setShowDatePicker}
            />
            <ClockArea
              date={values.clockTime}
              setDate={(e) =>
                setValues((preValues) => ({
                  ...preValues,
                  clockTime: e,
                }))
              }
              dateEnd={values.clockTimeEnd}
              setDateEnd={(e) =>
                setValues((preValues) => ({
                  ...preValues,
                  clockTimeEnd: e,
                }))
              }
              show={showClock}
              setShow={setShowClock}
            />
            {selectedProject && (
              <Grid
                gap="10px"
                display="flex"
                flexDirection={"row"}
                justifyContent={"space-between"}
                mb={"30px"}
              >
                <Typography>{`پروژه: ${selectedProject.name}`}</Typography>
                <Typography>{`بازه برگزاری پروژه: ${selectedProject.startAt} - ${selectedProject.endAt}`}</Typography>
              </Grid>
            )}
            <Grid gap="10px" display="flex" flexDirection={"row"}>
              <AsarFormikInput
                placeholder={"نام اردو را وارد کنید"}
                label="نام اردو"
                name={"tripName"}
              />
              <AsarFormikInput
                onClick={(e) => {
                  setShowDatePicker(e.currentTarget);
                }}
                readOnly={true}
                value={
                  values.date?.length >= 2
                    ? `${values.date[0].year}/${values.date[0].month}/${values.date[0].day} تا ${values.date[1].year}/${values.date[1].month}/${values.date[1].day} `
                    : values.date?.length >= 1
                      ? `${values.date[0].day}/${values.date[0].month}/${values.date[0].year}`
                      : ""
                }
                name={"date"}
                placeholder={"زمان شروع و پایان اردو را انتخاب کنید"}
                label="بازه زمانی اردو"
              />
              <InputCreateProject
                placeholder={"زمان شروع و پایان اردو را انتخاب کنید"}
                label="ساعت شروع و پایان"
                value={
                  values.clockTime
                    ? values.clockTime + " " + "تا" + " " + values.clockTimeEnd
                    : values?.endAt
                      ? `${values?.startAt?.split("-", 2)[1]} تا ${
                          values?.endAt?.split("-", 2)[1]
                        }`
                      : ""
                }
                onClick={(e) => {
                  setShowClock(e.currentTarget);
                }}
              />
            </Grid>
            <Grid
              display="flex"
              flexDirection={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <Typography color={"text.primary"}>منطقه‌ها</Typography>
              <Grid
                display="flex"
                alignItems="center"
                alignSelf={"end"}
                onClick={() => {
                  setValues((prevValues) => ({
                    ...prevValues,
                    areas: [
                      ...values.areas,
                      {
                        id: Math.round(Math.random() * 100000),
                        owner: undefined,
                        name: "",
                      },
                    ],
                  }));
                }}
                gap={"10px"}
                sx={{
                  cursor: "pointer",
                  backgroundColor: "var(--emr-primary)",
                  color: "white",
                  borderRadius: "8px",
                  padding: "6px 12px",
                }}
              >
                <PlusIcon color={"white"} />
                <Typography fontSize="16px">{"منطقه جدید"}</Typography>
              </Grid>
            </Grid>
            {values.areas.length > 0 &&
              values.areas.map((area, index) => (
                <Grid
                  display={"flex"}
                  flexDirection={"column"}
                  gap={"10px"}
                  key={index}
                  sx={{
                    backgroundColor: "var(--emr-background-color)",
                    padding: "10px 20px",
                    borderRadius: "8px",
                  }}
                >
                  <Grid
                    display={"flex"}
                    flexDirection={"row"}
                    justifyContent={"space-between"}
                  >
                    <Typography>{`اردو ${index + 1}`}</Typography>
                    {values.areas.length > 1 && (
                      <IconButton
                        onClick={() => {
                          if (edit) {
                            setLoading(true);
                            removeAreaFromTrip(tripDigest.id, area.id)
                              .then(() => {
                                setValues((prevValues) => ({
                                  ...prevValues,
                                  areas: values.areas.filter(
                                    (a) => a.id !== area.id,
                                  ),
                                }));
                              })
                              .catch(() => {})
                              .finally(() => setLoading(false));
                          }
                        }}
                      >
                        <TrashIcon />
                      </IconButton>
                    )}
                  </Grid>
                  <Grid display={"flex"} flexDirection={"row"} gap={"20px"}>
                    <InputCreateProject
                      placeholder={"نام منطقه را وارد نمایید"}
                      label="نام منطقه"
                      value={area.name ?? ""}
                      onChange={(e) =>
                        setValues({
                          ...values,
                          areas: values.areas.map((areaItr) => {
                            if (areaItr.id === area.id) {
                              return {
                                ...areaItr,
                                name: e.target.value,
                              };
                            }
                            return areaItr;
                          }),
                        })
                      }
                    />
                    <CustomizedHook
                      parentWidth={md ? "100%" : undefined}
                      width={md ? "100%" : undefined}
                      maxWidth={md ? "100%" : undefined}
                      onChange={(_, newValue) => {
                        setValues({
                          ...values,
                          areas: values.areas.map((areaItr) => {
                            if (areaItr.id === area.id) {
                              return {
                                ...areaItr,
                                owner: newValue.value,
                              };
                            }
                            return areaItr;
                          }),
                        });
                      }}
                      value={
                        options?.find((x) => x.value === area?.owner) || null
                      }
                      options={options}
                      placeholder={"انتخاب کنید"}
                      label="مسئول منطقه"
                    />
                  </Grid>
                </Grid>
              ))}
            {(errors?.areas || errors?.clockTime || errors?.clockTimeEnd) && (
              <Typography color={"error"}>
                {errors?.areas || errors?.clockTime || errors?.clockTimeEnd}
              </Typography>
            )}
            <Grid display={"flex"} flexDirection={"row"} gap={"10px"}>
              <Button
                sx={{ width: "100px" }}
                onClick={submitForm}
                variant="contained"
              >
                ذخیره
              </Button>
              <Button color="error" variant="outlined" onClick={onClose}>
                انصراف
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
}
